import classNames from 'classnames'
import { useCallback } from 'react'
import { useMatch, NavLink, useLocation } from 'react-router-dom'

import type { INavBarLink } from '../types'
import type { ReactElement } from 'react'

import { checkUrlMatch, subMenuMatch } from '../utils'

import './styles.scss'

export interface Props {
  authorizations: string[]
  hoveredItems: string[]
  isCollapsed: boolean
  level: number
  onHover: (value: string, level: number) => void
  parentUrl: string
  submenu: INavBarLink[]
}

const SubMenu = ({
  authorizations,
  hoveredItems,
  isCollapsed,
  level,
  onHover,
  parentUrl,
  submenu,
}: Props): ReactElement => {
  const location = useLocation()

  const match = useMatch(parentUrl)

  const isSubMenuCollapsed = isCollapsed ? true : !match && !subMenuMatch(submenu)

  const isSubLinkActive = useCallback(
    (url: string, withSubmenu: boolean) =>
      withSubmenu ? checkUrlMatch(location.pathname, url) : location.pathname.includes(url),
    [location.pathname]
  )

  const handleClickMenuItem = () => onHover('', level)

  return (
    <div
      className={classNames('submenu-container', {
        collapsed: isSubMenuCollapsed,
        external: isCollapsed,
      })}
    >
      {submenu.map(({ authorization, isNewFeature, name, submenu, url }, index) =>
        !authorization || authorizations.includes(authorization) ? (
          <div
            className={classNames('nav-link-submenu-item', {
              'submenu-active': isSubLinkActive(url, !!submenu),
            })}
            key={url + index}
          >
            <NavLink end onClick={handleClickMenuItem} to={url}>
              <div className="nav-link-title">
                {name}
                {isNewFeature ? <span className="new-feature-icon">New</span> : null}
              </div>
            </NavLink>
            {!!submenu ? (
              <SubMenu
                authorizations={authorizations}
                hoveredItems={hoveredItems}
                isCollapsed={isCollapsed}
                level={level + 1}
                onHover={onHover}
                parentUrl={parentUrl}
                submenu={submenu}
              />
            ) : null}
          </div>
        ) : null
      )}
    </div>
  )
}

export default SubMenu
